import { defineMessages } from 'react-intl';

export const translations = defineMessages<FilterCondition['operator']>({
  eq: {
    id: 'filter.condition.eq',
    defaultMessage: 'Equal to',
  },
  neq: {
    id: 'filter.condition.neq',
    defaultMessage: 'Not equal to',
  },
  matches: {
    id: 'filter.condition.matches',
    defaultMessage: 'Matches',
  },
  not_matches: {
    id: 'filter.condition.not_matches',
    defaultMessage: 'Does not match',
  },
  known: {
    id: 'filter.condition.known',
    defaultMessage: 'Known',
  },
  unknown: {
    id: 'filter.condition.unknown',
    defaultMessage: 'Unknown',
  },
  true: {
    id: 'filter.condition.true',
    defaultMessage: 'True',
  },
  false: {
    id: 'filter.condition.false',
    defaultMessage: 'False',
  },
  none_of: {
    id: 'filter.condition.none_of',
    defaultMessage: 'None of',
  },
  any_of: {
    id: 'filter.condition.any_of',
    defaultMessage: 'Any of',
  },
  between: {
    id: 'filter.condition.between',
    defaultMessage: 'Between',
  },
  not_between: {
    id: 'filter.condition.not_between',
    defaultMessage: 'Not between',
  },
  gt: {
    id: 'filter.condition.gt',
    defaultMessage: 'Greater than',
  },
  gte: {
    id: 'filter.condition.gte',
    defaultMessage: 'Greater or equal to',
  },
  lt: {
    id: 'filter.condition.lt',
    defaultMessage: 'Less than',
  },
  lte: {
    id: 'filter.condition.lte',
    defaultMessage: 'Less or equal to',
  },
  before: {
    id: 'filter.condition.before',
    defaultMessage: 'Before',
  },
  after: {
    id: 'filter.condition.after',
    defaultMessage: 'After',
  },
  in_last: {
    id: 'filter.condition.in_last',
    defaultMessage: 'In the last',
  },
  not_in_last: {
    id: 'filter.condition.not_in_last',
    defaultMessage: 'Not in the last',
  },
  all_of: {
    id: 'filter.condition.all_of',
    defaultMessage: 'All of',
  },
});

/** Unit labels for the `in_last` / `not_in_last` relative-date unit dropdown. */
export const durationUnitLabels = defineMessages({
  days: {
    id: 'filter.duration_unit.days',
    defaultMessage: 'Days',
  },
  months: {
    id: 'filter.duration_unit.months',
    defaultMessage: 'Months',
  },
  years: {
    id: 'filter.duration_unit.years',
    defaultMessage: 'Years',
  },
});

/** Pluralised unit labels for rendering a relative duration (e.g. "30 days"). */
export const durationUnitCounts = defineMessages({
  days: {
    id: 'filter.duration_count.days',
    defaultMessage: '{amount, plural, one {# day} other {# days}}',
  },
  months: {
    id: 'filter.duration_count.months',
    defaultMessage: '{amount, plural, one {# month} other {# months}}',
  },
  years: {
    id: 'filter.duration_count.years',
    defaultMessage: '{amount, plural, one {# year} other {# years}}',
  },
});
